var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "login_contant"
  }, [_c('h3', {
    staticClass: "login_tit"
  }, [_vm._v("아이디 찾기")]), _c('div', {
    staticClass: "login_form"
  }, [_c('span', [_vm._v("이름")]), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.name,
      expression: "input.name"
    }],
    class: {
      'validation_error': _vm.validObj.name.active
    },
    attrs: {
      "type": "text",
      "readonly": _vm.results !== null,
      "readonly": _vm.emailAuth.flag,
      "placeholder": "이름을 입력하세요."
    },
    domProps: {
      "value": _vm.input.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "name", $event.target.value);
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validObj.name.active,
      expression: "validObj.name.active"
    }],
    staticClass: "validation_text",
    domProps: {
      "textContent": _vm._s(_vm.validObj.name.msg)
    }
  })]), _c('span', [_vm._v("이메일")]), _c('div', {
    staticClass: "column_input"
  }, [_c('ul', {
    staticClass: "inp_column btn"
  }, [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.email,
      expression: "input.email"
    }],
    class: {
      'validation_error': _vm.validObj.email.active
    },
    attrs: {
      "type": "text",
      "readonly": _vm.results !== null,
      "placeholder": "이메일을 입력하세요.",
      "readonly": _vm.emailAuth.flag
    },
    domProps: {
      "value": _vm.input.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "email", $event.target.value);
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validObj.email.active,
      expression: "validObj.email.active"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.validObj.email.msg))])]), _c('li', {
    staticClass: "col_btn"
  }, [_c('button', {
    staticClass: "inp_btn",
    attrs: {
      "type": "button",
      "disabled": _vm.emailAuth.flag
    },
    on: {
      "click": _vm.sendEmailAuthCode
    }
  }, [!_vm.emailAuth.sendYn ? _c('span', [_vm._v("인증번호발송")]) : _c('span', [_vm._v("인증번호발송")])])])])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.emailAuth.sendYn,
      expression: "emailAuth.sendYn"
    }]
  }, [_vm._v("이메일 인증번호")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.emailAuth.sendYn,
      expression: "emailAuth.sendYn"
    }],
    staticClass: "column_input"
  }, [_c('ul', {
    staticClass: "inp_column btn"
  }, [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.emailAuth.value,
      expression: "emailAuth.value"
    }],
    class: _vm.emailAuth.validMessage != null && _vm.emailAuth.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "maxlength": "80",
      "readonly": _vm.emailAuth.flag
    },
    domProps: {
      "value": _vm.emailAuth.value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.emailAuth, "value", $event.target.value);
      }
    }
  }), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.displayTime))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.emailAuth.validMessage != null && _vm.emailAuth.validMessage != '',
      expression: "emailAuth.validMessage != null && emailAuth.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(" " + _vm._s(_vm.emailAuth.validMessage) + " ")])]), _c('li', {
    staticClass: "col_btn"
  }, [_c('button', {
    staticClass: "inp_btn",
    attrs: {
      "type": "button",
      "disabled": _vm.emailAuth.flag
    },
    on: {
      "click": _vm.verificationEmailAuthCode
    }
  }, [_vm._v(" 인증번호확인 ")])])])]), _vm._m(0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.results !== null,
      expression: "results !== null"
    }],
    staticClass: "bottom_area"
  }, [_c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_c('button', {
    staticClass: "login_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/account/find-pw');
      }
    }
  }, [_vm._v("비밀번호찾기 ")])]), _c('li', [_c('button', {
    staticClass: "login_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/account/logout');
      }
    }
  }, [_vm._v("로그인 ")])])])]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.results == null,
      expression: "results == null"
    }],
    staticClass: "login_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("아이디찾기")])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login_msg_area"
  }, [_c('p', {
    staticClass: "login_msg"
  }, [_vm._v("인증번호가 오지 않나요?")]), _c('div', {
    staticClass: "tooltip_box"
  }, [_c('span', {
    staticClass: "tooltip_ico"
  }), _c('div', {
    staticClass: "tooltip_txt"
  }, [_c('p', [_vm._v("발송한 메일이 스팸 메일로 분류된 것은 아닌지 확인해주세요. 스팸 메일함에도 메일이 없다면, 다시 한 번 ‘인증번호발송’을 눌러주세요.")])])])]);

}]

export { render, staticRenderFns }